/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spin a wheel to pick randomly from your own list.`)
};

const es_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gira una rueda para elegir al azar de tu propia lista.`)
};

const de_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drehe ein Glücksrad, um zufällig aus deiner eigenen Liste zu wählen.`)
};

const nl_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draai aan een rad om willekeurig te kiezen uit je eigen lijst.`)
};

const fr_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faites tourner une roue pour choisir au hasard dans votre propre liste.`)
};

const it_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fai girare una ruota per scegliere a caso dal tuo elenco.`)
};

const pt_br2_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gire uma roleta para escolher aleatoriamente entre os itens da sua lista.`)
};

const pt_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gire uma roda para escolher aleatoriamente da sua própria lista.`)
};

const ja_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分で入力したリストからルーレットを回してランダムに選びます。`)
};

const zh_dw_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转动转盘，从你自己的列表中随机选择。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_tool_description", locale)
	if (locale === "en") return en_dw_tool_description(inputs)
	if (locale === "es") return es_dw_tool_description(inputs)
	if (locale === "de") return de_dw_tool_description(inputs)
	if (locale === "nl") return nl_dw_tool_description(inputs)
	if (locale === "fr") return fr_dw_tool_description(inputs)
	if (locale === "it") return it_dw_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_dw_tool_description(inputs)
	if (locale === "pt") return pt_dw_tool_description(inputs)
	if (locale === "ja") return ja_dw_tool_description(inputs)
	return zh_dw_tool_description(inputs)
};